module.exports = "/images/cookie_checker.svg?beae5b25c562de92419cf8cd56eaea7b";